import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Browse pages whose `/:slug` child opens a quick look over the same list.
// Moving between the list and a product must not jump the list to the top.
const OVERLAY_ROOTS = ['/printing/all-a', '/printing/all-b'];
const rootOf = (path: string) => OVERLAY_ROOTS.find((r) => path === r || path.startsWith(`${r}/`));

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const previous = useRef(pathname);

  useEffect(() => {
    const root = rootOf(pathname);
    const sameList = root !== undefined && root === rootOf(previous.current);
    previous.current = pathname;
    if (!sameList) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
